import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header1"; // Import your Header component
import AboutUs from "./components/AboutUs"; // Import your AboutUs component
import HomePage from "./components/Home/HeroSection"; // Replace with your homepage component
import Footer from "./components/Footer1";
import Portfolio from "./components/Portfolio";
import ContactUs from "./components/ContactUs";
import NewsArticle from "./components/NewsArticle";
import TeamCarousel from "./components/Teams";
import TeamMemberDetail from "./components/Teams/TeamMemberDetail";
import ResilientFund from "./components/ResilientFund";
import HeroSec from "./components/Home/Hero";
import MobileFooter from "./components/MobileFooter";

const App = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTablet(window.innerWidth> 768 && window.innerWidth <= 1024);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HeroSec />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/resilient-fund" element={<ResilientFund />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/news-media" element={<NewsArticle />} />
        <Route path="/teams" element={<TeamCarousel isMobile={isMobile} isTablet={isTablet} />} />
        <Route path="/teams/member" element={<TeamMemberDetail />} />
      </Routes>
      {isMobile ? <MobileFooter /> : <Footer />}
    </Router>
  );
};

export default App;
